import React, { useEffect } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Close, Search } from '@lyearn/icons';
import { Box, Divider, Stack } from '@lyearn/ui';
import { SearchBar } from '@/components/SearchBar';
import { useAppConfig } from '@/hooks/useAppConfig';
import ImageList from '@/modules/corporate/components/ImageList';

import { useDesignContext } from '../../context/Design';
import useDesignCoverActions from '../../hooks/useDesignCoverActions';
import Header from './Header';

const Cover: React.FC = (props) => {
  const { currentCoverUrl, previewCover, setOverlayContent, setPreviewCover, onSubmitCover } =
    useDesignContext();
  const { t } = useTranslation();

  const {
    selectedCard,
    searchInput,
    setSearchInput,
    searchString,
    isSettingCover,
    uppy,
    uploadedItems,
    setCard,
    hideOverlay,
    setCoverImage,
  } = useDesignCoverActions(setOverlayContent, previewCover, setPreviewCover, onSubmitCover);
  const {
    site: { disabledUnsplash },
  } = useAppConfig();

  useEffect(() => {
    // Whenever the selectedCard is updated, we want to set that as the selected cover image
    if (currentCoverUrl !== selectedCard.url) {
      setCoverImage();
    }
  }, [selectedCard]);

  return (
    <Stack alignItems="center" className="h-full w-full bg-bg-secondary" direction="col">
      <Header hideOverlay={hideOverlay} />
      <Divider className="w-full" color="border-interactive-secondary" />
      {disabledUnsplash ? null : (
        <Box className="z-10 mt-16 h-40 w-full px-16">
          <SearchBar
            className="h-full border-none bg-s-info-light"
            endAdornment={
              <Close
                className="icon-close h-24 w-24 cursor-pointer fill-current text-icon-secondary hover:text-icon-active"
                onClick={() => setSearchInput('')}
              />
            }
            placeholder={t('Common:Design.SearchUnsplash')}
            size="medium"
            startAdornment={
              <Search className="h-20 w-20 flex-shrink-0 fill-current text-icon-secondary" />
            }
            value={searchInput}
            onChange={setSearchInput}
          />
        </Box>
      )}
      <ImageList
        coverUrl={previewCover.url}
        items={uploadedItems}
        searchString={searchString}
        selectedCard={selectedCard}
        setCard={setCard}
        uppy={uppy}
      />
    </Stack>
  );
};

export default Cover;
